import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { tap } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  IPermissionCategoryList,
  IPermissionGroupList,
  IPermissionList,
  IPermissionMappedWithGroup,
} from '../models/permission';

@Injectable({
  providedIn: 'root',
})
export class Permission {
  private baseUrl: string = `${environment.apiUrl}/permission`;

  constructor(private http: HttpClient) {}

  permissions = signal<IPermissionList[]>([]);
  isLoading = signal(false);
  errorMessage = signal('');

  permissionCategories = signal<IPermissionCategoryList[]>([]);
  permissionGroups = signal<IPermissionGroupList[]>([]);

  permissionMappedWithGroup = signal<IPermissionMappedWithGroup[]>([]);

  getPermissionsList(): void {
    this.isLoading.set(true);
    this.errorMessage.set('');

    this.http.get<IPermissionList[]>(`${this.baseUrl}/list`).subscribe({
      next: (data) => {
        this.permissions.set(data);
        this.isLoading.set(false);
      },
      error: (err) => {
        console.error(err);
        this.errorMessage.set('Failed to load permissions');
        this.isLoading.set(false);
      },
    });
  }

  getPermissionCategoryList(): void {
    this.isLoading.set(true);
    this.errorMessage.set('');

    this.http
      .get<IPermissionCategoryList[]>(`${this.baseUrl}/list/category`)
      .subscribe({
        next: (data) => {
          this.permissionCategories.set(data);
          this.isLoading.set(false);
        },
        error: (err) => {
          console.error(err);
          this.errorMessage.set('Failed to load permissions');
          this.isLoading.set(false);
        },
      });
  }

  getPermissionGroupList(): void {
    this.isLoading.set(true);
    this.errorMessage.set('');

    this.http
      .get<IPermissionGroupList[]>(`${this.baseUrl}/list/group`)
      .subscribe({
        next: (data) => {
          this.permissionGroups.set(data);
          this.isLoading.set(false);
        },
        error: (err) => {
          console.error(err);
          this.errorMessage.set('Failed to load permissions');
          this.isLoading.set(false);
        },
      });
  }

  getPermissionMappedWithGroupList(): void {
    this.isLoading.set(true);
    this.errorMessage.set('');

    this.http
      .get<
        IPermissionMappedWithGroup[]
      >(`${this.baseUrl}/list/permission/group`)
      .subscribe({
        next: (data) => {
          this.permissionMappedWithGroup.set(data);
          this.isLoading.set(false);
        },
        error: (err) => {
          console.error(err);
          this.errorMessage.set('Failed to load permissions');
          this.isLoading.set(false);
        },
      });
  }

  updatePermission(permission: IPermissionList) {
    return this.http
      .put<IPermissionList>(
        `${this.baseUrl}/update/${permission.id}`,
        permission,
      )
      .pipe(
        tap((updated) => {
          const current = this.permissions();
          const index = current.findIndex((p) => p.id === updated.id);
          current[index] = updated;
          this.permissions.set([...current]);
        }),
      );
  }
}
